import { Grid } from '@mui/material'
import React from 'react'
import CustomTabs from '../../components/Tabs/Tabs'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { Link, useNavigate } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { useAuth } from '@praxis/component-auth'
import BottomBar from 'components/BottomBar'
import { useEnv } from '@praxis/component-runtime-env'
import { showNotification } from 'store/notification/actionCreator'
import {
  getVendorEmailsById,
  setOrderSamplesFrom,
  setSampleData,
} from 'store/order/actionCreator'
import {
  tabList,
  dataLabelsTabRemaining,
  dataLabelsOrdered,
  parentFields,
  tcinFields,
} from './VirtualBundlesConstants'
import {
  Accordion,
  AccordionDetails,
  Typography,
  AccordionSummary,
  Button,
  Box,
  Tooltip,
  Paper,
  CircularProgress,
  IconButton,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import FlexibleTable from 'components/EnhancedTable/FlexibleTable'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import {
  getAVirtualBundleFromSearch,
  getAVirtualBundleFromItems,
  showPopup,
  closePopup,
  updateSampleFieldsData,
  setVirtualBundlesFromItems,
  getAVirtualBundleDataSuccess,
} from 'store/virtualBundles/actionCreator'
import { getDisplayImage } from 'util/CommonUtils'
import { isEmpty, cloneDeep, isNull, isUndefined, isEqual } from 'lodash'
import { getFieldValue, getFormattedData } from 'mappers/virtualBundleMapper'
import { setHeaderTitleArray } from 'store/layout/actionCreator'
import { dataTabLabelsShipped } from 'enums/tableTabs'
import TabbedPopUp from 'components/PopUp/TabbedPopUp'
import { getTitle, makeTabTables } from 'util/Table'
import {
  downloadContactSheet,
  triggerDownload,
} from 'store/searchInventory/actionCreator'
import { SAMPLE } from 'enums/Tabs'
import { LoadingButton } from '@mui/lab'
import NotesIcon from '@mui/icons-material/Notes'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import DownloadIcon from '@mui/icons-material/Download'
import Checkbox from '@material-ui/core/Checkbox'
import ShowIf from 'components/ShowIf'
const useStyles = makeStyles((theme) => ({
  shootTypeLabel: {
    fontSize: '14px',
    fontWeight: 'bold',
  },
  toolBar: {
    display: 'flex',
  },
  orderButtonLink: {
    textDecoration: 'auto',
  },
  filterTitle: {
    width: '300px',
    paddingTop: '10px',
    paddingBottom: '20px',
  },
  accordianContentClass: {
    fontWeight: 'normal',
    fontSize: '0.8rem',
    paddingTop: '20px',
  },
  swipeableDrawerElementsContainer: {
    overflow: 'hidden',
    backgroundColor: '#366cd9',
    color: '#fff',
  },
  errorIcon: {
    marginTop: '25px',
    color: '#B85300',
  },
  orderButton: {
    width: 'auto',
    margin: '0px 8px',
    color: '#366cd9',
    backgroundColor: '#fff',
  },
  swipeableDrawer: {
    padding: '1%',
    overflow: 'hidden',
    alignItems: 'center',
  },
  tabButton: {
    float: 'right',
  },
  progress: {
    alignItems: 'center',
  },
  zoomCls: {
    transition: 'transform .2s' /* Animation */,
    display: 'flex',
    justifyContent: 'center',
    '&:hover': {
      // transform: 'scale(1.5)',
    },
  },
}))
const VirtualBundleDetailsPage = () => {
  const classes = useStyles()
  const [itemData, setItemData] = React.useState([])
  const { subPageName } = useParams()
  const [itemAccordianExpanded, setItemAccordianExpanded] = React.useState([])
  const [accordianExpanded, setAccordionExpanded] = React.useState(false)
  const [selectedTcins, setSelectedTcins] = React.useState([])
  const [loadingComplete, setLoading] = React.useState(true)
  const [downloadStateAllItems, setDownloadStateAllItems] =
    React.useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const auth = useAuth()
  const {
    selectedVirtualBundleDetails = {},
    virtualBundlesFromItems = [],
    virtualBundleRequestPending,
    virtualBundlesFromSearch = [],
    virtualBundleParent = {},
    popupIsVisible = false,
    item: popupItem = {},
    downloadLoadingStatus = false,
    downloadLoadingStatusXlsx = false,
    downloadLoadingStatusPdf = false,
  } = useSelector(
    ({
      virtualBundlesReducer: {
        selectedVirtualBundleDetails = {},
        virtualBundlesFromItems = [],
        virtualBundleRequestPending = false,
        virtualBundlesFromSearch = [],
        virtualBundleParent = {},
        popupIsVisible = false,
        item = {},
      },
      searchInventory: {
        downloadLoadingStatus = false,
        downloadLoadingStatusXlsx = false,
        downloadLoadingStatusPdf = false,
      },
    }) => {
      return {
        selectedVirtualBundleDetails,
        virtualBundlesFromItems,
        virtualBundleRequestPending,
        virtualBundlesFromSearch,
        virtualBundleParent,
        popupIsVisible,
        item,
        downloadLoadingStatus,
        downloadLoadingStatusXlsx,
        downloadLoadingStatusPdf,
      }
    }
  )
  const location = useLocation()
  const currentURI = location.pathname + location.search // full path with query params
  let env = useEnv()
  React.useEffect(() => {
    const { vbName = '' } = selectedVirtualBundleDetails || {}
    dispatch(
      setHeaderTitleArray([
        { title: `Virtual Bundles`, link: `/${'virtualBundles'}` },
        { title: `${vbName}`, link: currentURI },
      ])
    )
    dispatch(getAVirtualBundleFromItems([subPageName]))
    dispatch(getAVirtualBundleFromSearch(subPageName))
  }, [])

  React.useEffect(() => {
    const { VirtualBundlesProjectId = '' } = env
    if (!isEmpty(virtualBundlesFromItems) && !virtualBundleRequestPending) {
      const data = getFormattedData(
        cloneDeep(virtualBundlesFromItems),
        cloneDeep(virtualBundlesFromSearch),
        VirtualBundlesProjectId
      )
      setItemData(data)
    }
  }, [virtualBundlesFromItems, virtualBundlesFromSearch])
  const prevItemDataRef = React.useRef()

  React.useEffect(() => {
    if (!isEmpty(itemData) && !isEqual(itemData, prevItemDataRef.current)) {
      setLoading(false)
    }
    prevItemDataRef.current = itemData
  }, [itemData])

  React.useEffect(() => {
    return () => {
      dispatch(setHeaderTitleArray([]))
      dispatch(closePopup())
      setItemData([])
      setItemAccordianExpanded([])
      setAccordionExpanded(false)
      dispatch(setVirtualBundlesFromItems([]))
      dispatch(getAVirtualBundleDataSuccess([]))
      dispatch(updateSampleFieldsData({}))
    }
  }, [])
  const handleSetAccourdianExpanded = (expanded, item) => {
    const obj = {
      [item?.tcin]: expanded,
    }
    setItemAccordianExpanded((prevState) => ({
      ...prevState,
      ...obj,
    }))
  }
  const updateSampleFieldsDataLocal = (data) => {
    dispatch(updateSampleFieldsData(data))
  }
  const renderTabbedPopUp = () => {
    const tabsList = dataTabLabelsShipped
    return (
      <TabbedPopUp
        dataTabLabels={tabsList}
        isVisible={popupIsVisible}
        data={makeTabTables(
          popupItem,
          classes,
          tabsList,
          updateSampleFieldsDataLocal,
          itemData
        )}
        onClose={() => dispatch(closePopup())}
        title={getTitle(popupItem)}
        fullWidth={true}
      />
    )
  }
  const setOrderItems = (item = {}) => {
    const { session: { userInfo: { lanId = '' } = {} } = {} } = auth
    const data = itemData.filter((i) => selectedTcins.includes(i.tcin))
    let vendorIdEmpty = []
    const { DefaultVirtualBundleLocation = '' } = env
    const newSelected = data.map((i = {}) => {
      const {
        vbParentTcin = '',
        quantity = Number(1),
        ship_to_location = '',
      } = i
      if (ship_to_location) {
        i = Object.assign({}, i, { shipTo: ship_to_location })
      }
      if (isNull(i?.vendorId) || isUndefined(i?.vendorId)) {
        vendorIdEmpty.push(i)
      }
      return {
        ...i,
        vendorEmail: '',
        emailVmm: null,
        vendorBPIds: '',
        bpidsVmm: null,
        studioNotes: '',
        vendorNotes: '',
        userId: lanId,
        project: '',
        virtualBundleParent: vbParentTcin,
        shipTo: DefaultVirtualBundleLocation,
        quantity: 1,
      }
    })
    const vendorIds = data.map((i) => i?.vendorId)
    if (isEmpty(vendorIdEmpty)) {
      dispatch(setOrderSamplesFrom(window.location.pathname))
      dispatch(setSampleData(newSelected))
      dispatch(getVendorEmailsById(vendorIds))
    } else {
      dispatch(setOrderSamplesFrom(''))
      dispatch(
        showNotification(
          true,
          `Some of the samples selected have no vendor Id`,
          'error'
        )
      )
    }
  }
  const toggleOpen = () => {
    if (!isEmpty(selectedTcins)) {
      return true
    } else {
      return false
    }
  }
  const renderSwipeableDrawer = () => {}
  const renderBottomBar = () => {
    const { isMerchantApprovedForPublishing = false } =
      virtualBundleParent || {}
    return (
      <BottomBar
        anchor="bottom"
        variant={'persistent'}
        open={toggleOpen()}
        onOpen={() => null}
        onClose={() => null}
        showClearAll={selectedTcins > 0}
        onClearAllClick={() => {
          setSelectedTcins([])
        }}
      >
        <div className={classes.swipeableDrawerElementsContainer}>
          <Grid container className={classes.swipeableDrawer} spacing={4}>
            <Grid item>
              <Typography
                variant="body1"
                component="body1"
                className={classes.defaultButton}
              >
                {selectedTcins.length} Selected
              </Typography>
            </Grid>
          </Grid>
        </div>
      </BottomBar>
    )
  }
  const InfoGridItem = ({ xs, label, value }) => {
    return (
      <Grid item xs={xs} style={{ maxWidth: '10%', maxHeight: '5%' }}>
        <Typography style={{ fontWeight: 'bold' }}>
          {label}
          <Typography className={classes.accordianContentClass}>
            {value}
          </Typography>
        </Typography>
      </Grid>
    )
  }
  const downloadCSV = (e, downloadType = '', item = {}) => {
    const sampleIds = item?.samples?.map((sample) => sample.sampleId) || []
    isEmpty(item)
      ? setDownloadStateAllItems(true)
      : setDownloadStateAllItems(false)
    const params = isEmpty(item)
      ? {
          requestPayload: {
            include_filters: {
              virtual_bundle_parent_ids: [Number(virtualBundleParent?.tcin)],
            },
            exclude_filters: {},
          },
        }
      : {
          requestPayload: {
            include_filters: {
              sample_id: [...sampleIds],
            },
            exclude_filters: {},
          },
        }
    dispatch(downloadContactSheet(params, downloadType, SAMPLE, () => {}))
  }
  const renderContent = () => {
    const { tcin = '', imageUrl = '' } = virtualBundleParent || {}
    const { vbName = '' } = selectedVirtualBundleDetails || {}
    return (
      <>
        <Accordion
          onChange={(e, expanded) => setAccordionExpanded(expanded)}
          defaultExpanded={false}
          expanded={accordianExpanded}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            style={{
              backgroundColor: '#E5E4E2',
            }}
          >
            <Typography variant="h6">
              Virtual Bundle Parent Info - {tcin}
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            style={{
              backgroundColor: '#f5f5f5',
              border: '1px solid #ccc',
            }}
          >
            <Grid
              container
              spacing={3}
              alignItems="flex-start"
              style={{ width: '100%' }}
            >
              <Grid item xs={2}>
                <Box display="flex" flexDirection="column">
                  {getDisplayImage(imageUrl, 100, 100)}
                </Box>
              </Grid>
              {parentFields.map((field, idx) => (
                <InfoGridItem
                  key={idx}
                  label={field?.label}
                  xs={field?.xs}
                  value={getFieldValue(
                    field,
                    virtualBundleParent,
                    vbName,
                    dispatch,
                    auth
                  )}
                />
              ))}
            </Grid>
          </AccordionDetails>
        </Accordion>
        <Grid
          container
          alignItems="center"
          spacing={2}
          justifyContent="space-between"
          style={{ marginTop: '20px', paddingLeft: '10px' }}
        >
          <Grid item style={{ display: 'flex', alignItems: 'center' }}>
          
          </Grid>
          <Grid item style={{ alignContent: 'flex-end' }}>
            <LoadingButton
              loading={downloadStateAllItems ? downloadLoadingStatus : false}
              loadingIndicator={
                <CircularProgress
                  color="primary"
                  style={{ color: '#2F4F4F' }}
                  size={50}
                />
              }
            >
              <IconButton
                data-cy="downloadAll"
                id="downloadAll"
                aria-label="Download"
                onClick={(e) => downloadCSV(e, 'CSV')}
              >
                <DownloadIcon />
              </IconButton>
            </LoadingButton>
            <Tooltip title="Contact Sheet XLSX">
              <LoadingButton
                loading={
                  downloadStateAllItems ? downloadLoadingStatusXlsx : false
                }
                loadingIndicator={
                  <CircularProgress
                    color="primary"
                    style={{ color: '#2F4F4F' }}
                    size={50}
                  />
                }
              >
                <IconButton
                  data-cy="contactSheetDownload"
                  id="contactSheetDownload"
                  aria-label="Contact Sheet XLSX Download"
                  onClick={(e) => downloadCSV(e, 'XLSX')}
                >
                  <NotesIcon />
                </IconButton>
              </LoadingButton>
            </Tooltip>
            <Tooltip title="Contact Sheet PDF">
              <LoadingButton
                loading={
                  downloadStateAllItems ? downloadLoadingStatusPdf : false
                }
                loadingIndicator={
                  <CircularProgress
                    color="primary"
                    style={{ color: '#2F4F4F' }}
                    size={50}
                  />
                }
              >
                <IconButton
                  data-cy="contactSheetDownload"
                  id="contactSheetDownload"
                  aria-label="Contact Sheet PDF Download"
                  onClick={(e) => downloadCSV(e, 'PDF')}
                >
                  <PictureAsPdfIcon />
                </IconButton>
              </LoadingButton>
            </Tooltip>
          </Grid>
        </Grid>

        {loadingComplete ? (
          <Grid
            container
            id="samplesProgressBar"
            xs={12}
            spacing={3}
            justifyContent="center"
            alignItems="center"
            style={{ minHeight: '300px', display: 'flex' }} // Add this line
          >
            <CircularProgress className={classes.progress} />
          </Grid>
        ) : (
          itemData.map((item) => {
            return (
              <Accordion
                onChange={(e, expanded) =>
                  item?.samples.length > 0
                    ? handleSetAccourdianExpanded(expanded, item)
                    : null
                }
                defaultExpanded={itemAccordianExpanded[item?.tcin] || false}
                expanded={
                  item?.samples.length > 0
                    ? itemAccordianExpanded[item?.tcin] || false
                    : false
                }
                style={{ marginTop: '8px', marginBottom: '8px' }}
              >
                <AccordionSummary
                  expandIcon={
                    item.samples.length > 0 ? <ExpandMoreIcon /> : null
                  }
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  style={{
                    boxShadow: !itemAccordianExpanded[item?.tcin]
                      ? '0 2px 8px rgba(0,0,0,0.12)'
                      : 'none',
                    cursor: item?.samples.length > 0 ? 'pointer' : 'default',
                    backgroundColor: 'rgb(237 246 249)',
                  }}
                >
                  <Grid
                    container
                    spacing={3}
                    alignItems="flex-start"
                    style={{
                      width: '100%',
                    }}
                  >
                    {tcinFields.map((field, idx) => (
                      <InfoGridItem
                        key={idx}
                        label={field?.label}
                        xs={field?.xs}
                        value={getFieldValue(field, item, '', dispatch, auth)}
                      />
                    ))}
                  </Grid>
                </AccordionSummary>
                <AccordionDetails>
                  <FlexibleTable
                    cascadeFieldKeys={[]}
                    columnData={dataLabelsOrdered}
                    clickableColumn={['description']}
                    showPopup={(e) => dispatch(showPopup(e))}
                    onClick={() => {}}
                    data={item?.samples || []}
                    enableSearch
                    enableSpacer={false}
                    isLoading={virtualBundleRequestPending}
                    // enableToolbar={false}
                    disableTablePagination
                    enableDownload={itemData.length > 0}
                    enableContactSheetDownload={itemData.length > 0}
                    downloadFunction={(e) => downloadCSV(e, 'CSV', item)}
                    downloadCSFunction={(e) => downloadCSV(e, 'XLSX', item)}
                    downloadCSFunctionPDF={(e) => downloadCSV(e, 'PDF', item)}
                    downloadLoadingStatus={
                      !downloadStateAllItems ? downloadLoadingStatus : false
                    }
                    downloadLoadingStatusXlsx={
                      !downloadStateAllItems ? downloadLoadingStatusXlsx : false
                    }
                    downloadLoadingStatusPdf={
                      !downloadStateAllItems ? downloadLoadingStatusPdf : false
                    }
                  />
                </AccordionDetails>
              </Accordion>
            )
          })
        )}
        {!!popupIsVisible && renderTabbedPopUp()}
      </>
    )
  }

  return (
    <Grid>
      <Grid container justifyContent={'flex-end'}>
        <Button
          variant="text"
          color="primary"
          component={Link}
          to="/virtualBundles"
          startIcon={<ArrowBackIcon />}
          className={classes.filtersContentCls}
        >
          {'Back To virtual Bundles'}
        </Button>
      </Grid>
      {virtualBundleParent?.isMerchantApprovedForPublishing ? (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <span style={{ fontSize: 14, fontStyle: 'italic', color: '#B85300' }}>
            Only VBPs approved for publishing are available for ordering.
          </span>
        </div>
      ) : (
        <></>
      )}
      {renderContent()}
      <ShowIf condition={toggleOpen()}>{renderBottomBar()}</ShowIf>
    </Grid>
  )
}

export default VirtualBundleDetailsPage
